export default __webpack_public_path__ + "static/media/logo.45da744d.png";